var Events;
(function (Events) {
    // Click Events
    Events["LANDER_CLICK"] = "LanderClick";
    Events["FIRST_CLICK"] = "FirstClick";
    Events["SECOND_CLICK"] = "SecondClick";
    Events["CONDITIONAL_CLICK"] = "ConditionalClick";
    Events["CONTENT_CLICK"] = "ContentClick";
    Events["CONTENT_BLOCKED"] = "ContentBlocked";
    Events["NOT_CONTENT_BLOCKED"] = "NotContentBlocked";
    Events["FORBIDDEN"] = "Forbidden";
    Events["CONTINUE_CLICK"] = "ContinueClick";
    Events["OPTIN_CHECKED"] = "OptinChecked";
    Events["OPTIN_UNCHECKED"] = "OptinUnchecked";
    Events["OPTIN_CONFIRM"] = "OptinConfirm";
    Events["TERMS_CHECKED"] = "TermsChecked";
    Events["TERMS_UNCHECKED"] = "TermsUnchecked";
    Events["EXIT_CLICK"] = "ExitClick";
    Events["WIFI_CLICK"] = "WifiClick";
    Events["OPEN_EXTERNAL_CLICK"] = "OpenExternalClick";
    Events["PAY_BY_CARD_CLICK"] = "PayByCardClick";
    Events["ORIENTATION_CHANGE"] = "OrientationChanged";
    Events["PAGE_TIMEOUT"] = "PageTimeout";
    Events["SLIDER_TRIGGER"] = "SliderTrigger";
    Events["TRY_FOR_FREE"] = "TryForFree";
    Events["CANCEL_CLICK"] = "CancelClick";
    Events["CONTENT_CANCEL_CLICK"] = "ContentCancelClick";
    Events["OTP_CHALLENGE"] = "OtpChallenge";
    Events["CONSENT_TICKBOX_CHANGED"] = "ConsentTickboxChanged";
    Events["OTP_REDIRECT_CLICK"] = "OtpRedirectClick";
    Events["CTA_SHOWN"] = "CTAShown";
    Events["OTP_VALIDATE_SUCCESS"] = "OtpValidateSuccess";
    // Subscription events
    Events["SUBSCRIPTION_FAILED"] = "SubscriptionFailed";
    Events["SUBSCRIPTION_SUCCEEDED"] = "SubscriptionSucceeded";
    Events["SUBSCRIPTION_CANCELLED"] = "SubscriptionCancelled";
    Events["SUBSCRIPTION_EXISTS"] = "SubscriptionExists";
    Events["SUBSCRIPTION_NOT_FOUND"] = "SubscriptionNotFound";
    Events["SUBSCRIPTION_RESPONSE"] = "SubscriptionResponse";
    Events["CHECKING_SUBSCRIPTION"] = "CheckingSubscription";
    Events["PRE_SUBSCRIBE"] = "PreSubscribe";
    Events["SUBSCRIBE"] = "Subscribe";
    Events["VERIFYING_SUBSCRIPTION"] = "VerifyingSubscription";
    Events["VERIFY_SUBSCRIPTION"] = "VerifySubscription";
    // Identification events
    Events["IDENTIFY_CALLED"] = "IdentifyCalled";
    Events["IDENTIFY_SUCCESS"] = "IdentifySuccess";
    Events["IDENTIFY_FAILURE"] = "IdentifyFailure";
    Events["IDENTIFY_ERROR"] = "IdentifyError";
    Events["ACCESS_DENIED"] = "AccessDenied";
    Events["ACCESS_GRANTED"] = "AccessGranted";
    Events["UNIDENTIFIED_USER"] = "UnidentifiedUser";
    // Integrator events
    Events["INTEGRATOR_ERROR"] = "IntegratorError";
    Events["INTEGRATOR_CALL_SUCCEEDED"] = "IntegratorCallSucceeded";
    Events["INTEGRATOR_INIT_SUCCEEDED"] = "IntegratorInitSucceeded";
    Events["INTEGRATOR_LOAD_ERROR"] = "IntegratorLoadError";
    // Stripe events
    Events["STRIPE_LOAD_ERROR"] = "StripeLoadError";
    Events["STRIPE_REDIRECTING"] = "StripeRedirecting";
    // Flow events
    Events["FRAUD_DETECTED"] = "FraudDetected";
    Events["SHOWN_LANDING_PAGE"] = "ShownLandingPage";
    Events["SHOWN_LOGIN_PAGE"] = "ShownLoginPage";
    Events["SHOWN_LANDER"] = "ShownLander";
    Events["SHOW_WIFI"] = "ShowWifi";
    Events["LANGUAGE_SWITCHED"] = "LanguageSwitched";
    Events["PAGE_RELOAD"] = "ReloadPage";
    Events["REDIRECT_TO_PRODUCT"] = "RedirectToProduct";
    Events["REDIRECT_TO_LANDING_PAGE"] = "RedirectToLandingPage";
    Events["REDIRECTING"] = "Redirecting";
    Events["SHOWN_SUBSCRIBE_BUTTON"] = "ShownSubscribeButton";
    Events["FLOW_EXIT"] = "FlowExit";
    Events["FLOW_EXIT_CLICKED"] = "FlowExitClicked";
    Events["IFRAME_LOADED"] = "IframeLoaded";
    Events["FORCE_HTTP"] = "ForceHttp";
    Events["FORCE_HTTPS"] = "ForceHttps";
    Events["NAVIGATION_TIMING"] = "NavigationTiming";
    Events["PERFORMANCE_TRACKING"] = "PerformanceTracking";
    // OTP events
    Events["OTP_CHALLENGE_SHOWN"] = "OtpChallengeShown";
    Events["OTP_CHALLENGE_SUBMIT"] = "OtpChallengeSubmit";
    Events["OTP_PIN_VALIDATE_SHOWN"] = "OtpChallengeShown";
    Events["OTP_CORRECT_PIN"] = "OtpCorrectPin";
    Events["OTP_PIN_EXPIRED"] = "OtpPinExpired";
    Events["OTP_INCORRECT_PIN"] = "OtpIncorrectPin";
    Events["OTP_GENERATE_SUCCESS"] = "OtpGenerateSuccess";
    Events["OTP_GENERATE_FAILURE"] = "OtpGenerateFailure";
    Events["OTP_CHALLENGE_CONFIRM"] = "OtpChallengeConfirm";
    Events["OTP_CHALLENGE_VALIDATE"] = "OtpChallengeValidate";
    Events["OTP_VALIDATE_FAILURE"] = "OtpValidateFailure";
    // PIN events
    Events["PIN_GENERATE_SUCCESS"] = "PinGenerateSuccess";
    Events["PIN_GENERATE_FAILURE"] = "PinGenerateFailure";
    Events["PIN_CHALLENGE_VALIDATE"] = "PinChallengeValidate";
    Events["AUTORENEW_INPUT_CHANGED"] = "AutorenewInputChanged";
    // Plan selection events
    Events["PLAN_CHOSEN"] = "PlanChosen";
    // App lifecycle events
    Events["APP_INIT"] = "AppInit";
    Events["APP_POST_INIT"] = "AppPostInit";
    Events["NOTIFICATION_ERROR"] = "NotificationError";
    // Universal Login events
    Events["UNIVERSAL_LOGIN_LOGIN_BUTTON_CLICKED"] = "UniversalLoginLoginButtonClicked";
    Events["UNIVERSAL_LOGIN_SIGNUP_BUTTON_CLICKED"] = "UniversalLoginSignupButtonClicked";
})(Events || (Events = {}));
export default Events;
